import i18next from "i18next";

export const language = () => {
  return i18next.language;
};
